<template>
  <div :class="$style['panel--qrcode']" class="flex flex-col" ref="rootDom">
    <div :class="$style['panel-title']">
      {{ $t("nav_oper.qrcode_title") }}
    </div>
    <div :class="$style['panel-body']">
      <div :class="$style['qrcode-box']" :id="qrcodeID"></div>
    </div>
    <div :class="$style['panel-foot']">
      <a :class="$style['btn--download']" :href="downloadUrl" target="_blank">
        {{ $t("nav_oper.download_btn") }}
      </a>
    </div>
  </div>
</template>
<script>
import {useLighterBorder} from '../../plugins/use-lighter-border'
import {mapGetters} from 'vuex'
import QRcode from 'qrcodejs2'
import {getDomains} from '@/apis/user'
import urls from "@/utils/baseUrl";
import {buildMainSiteUrl} from '@/utils/navigate-nav-item'

export default {
  name: "AppDownloadQRCode",
  data() {
    return {
      cleanupLighterBorder: null,
      domain: '',
      linkUrl: urls.linkUrl
    }
  },
  props: {
    qrcodeID: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapGetters(['invitationCode', 'language']),
    downloadUrl() {
      return buildMainSiteUrl(this.linkUrl, '/download', this.language)
    },
  },
  mounted() {
    this.cleanupLighterBorder = useLighterBorder(
        this,
        this.$refs.rootDom
    );
    this.getDomains()
  },
  methods: {
    // 获取二维码
    getDomains() {
      getDomains().then((res) => {
        this.domain = res.data
        this.qrcode()
      })
    },
    // 生成二维码
    qrcode() {
      var _this = this
      const invitationQuery = this.invitationCode
        ? `?invitationCode=${encodeURIComponent(this.invitationCode)}`
        : ''
      const domain = String(_this.domain || '').replace(/\/+$/, '')
      let qrcode = new QRcode(this.qrcodeID, {
        width: 120,
        height: 120, // 高度
        text: `${domain}/download${invitationQuery}`, // 二维码内容
      })
      // console.log(invitationCode)
    },
  },
  beforeDestroy() {
    if (this.cleanupLighterBorder) {
      this.cleanupLighterBorder();
    }
  },
};
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/_mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .panel--qrcode {
    background-color: #fff;
    box-shadow: 0 12px 30px 0 rgba(#000, 0.1);

    .panel-title {
      color: #000;
    }
  }
}
.panel--qrcode {
  --border-width: 1px;
  font-size: 12px;
  font-weight: 600;
  line-height: em(16px, 12px); /* 133.333% */

  width: 165px;
  min-width: 165px;
  padding: 12px 16px;

  transition: 0.26s ease;
  text-align: center;

  border: var(--border-width) solid rgba(#fff, 0.1);
  border-radius: 8px;
  background: #1f1f1f;
  box-shadow: 0 12px 30px 0 rgba(#000, 0.3);

  gap: 12px;

  &::before {
    position: absolute;
    bottom: 100%;
    left: 0;

    display: block;

    width: 100%;
    height: 20px;

    content: "";
  }

  .panel-title {
    font-weight: 400;

    color: #eaecef;
  }

  .qrcode-box {
    @include image-placeholder(1, 1);
    overflow: hidden;
    width: 130px;
    height: 130px;
    border-radius: 6px;
    background: #FFF;
    padding: 4px;
    border: 1px solid color(var(--font-color), 0.1);
    >img{
      width: auto;
      height: auto;
      position: relative;
    }
    &::after{
      display: none;
    }
  }

  .btn--download {
    display: block;

    padding: 8px;

    white-space: nowrap;

    color: #000;
    border-radius: 4px;
    background-color: color(var(--theme-color));
  }
}
</style>
